interface IChatMemberProps {
  id: number;
  name: string;

  // Extra attributes
  branchId: number | null;
}

export class MChatMember {
  props: IChatMemberProps;

  constructor(props: IChatMemberProps) {
    this.props = props;
  }
}
